import 'babel-polyfill'
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import router from './router'
import store from './store'
import axios from 'axios'
import echarts from 'echarts'
import ElementUI from 'element-ui'
import common from './api/common'
import {post,get,patch} from './api/axios'
import * as filter from './api/filter'
import directive from './api/directive'
import Messages from './api/message'
import Pagination from './components/Pagination/index';
import SelectAll from './components/SelectAll/index';

//引用第三方样式
import 'element-ui/lib/theme-chalk/index.css'
import './assets/element/element.css'
import './assets/fxn/fxn.css'
import './assets/fxn/common.css'
import './assets/fxn/style.css'
import './assets/fxn/iconfont.css'
import './assets/baseStyle/common.css'


Vue.use(Vuex)
Vue.use(ElementUI)
Vue.use(require('vue-wechat-title'))
Vue.prototype.axios = axios
Vue.prototype.post=post;
Vue.prototype.get=get;
Vue.prototype.$http=axios;
Vue.prototype.common = common
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false
Vue.prototype.$message = Messages


Vue.prototype.token = JSON.parse(localStorage.getItem('token'));

let OpenAside = new Vue()
Vue.prototype.OpenAside = OpenAside


// 全局组件挂载
Vue.component('Pagination', Pagination)
Vue.component('SelectAll', SelectAll)

//全局过滤器
Object.keys(filter).forEach(key => { 
  Vue.filter(key, filter[key]) 
})

//全局指令
Object.keys(directive).forEach(key =>{
  Vue.directive(key, directive[key])
})

//配置模板导入/导出的URL地址---本地
// Vue.prototype.WebSocketUrl = 'wss://amcmj_api_static.amcmj.com:2344'
// Vue.prototype.TextUrl = 'https://amcmj_api_static.amcmj.com/'
// axios.defaults.baseURL = 'https://amcmj_api.amcmj.com/'
// Vue.prototype.webUrl = 'https://amcmj_os.amcmj.com/'
// Vue.prototype.callcenterUrl = "https://backend.amcmj.com/"
// Vue.prototype.webrtcUrl = "https://znyh.amcmj.com/"

//配置模板导入/导出的URL地址---正式
Vue.prototype.WebSocketUrl = 'wss://server.amcmj.com:2345/'
Vue.prototype.TextUrl = 'https://server.amcmj.com/'
axios.defaults.baseURL = 'https://api.amcmj.com/'
Vue.prototype.webUrl = 'https://os.amcmj.com/'
Vue.prototype.callcenterUrl = "https://op_api.amcmj.com/"
Vue.prototype.webrtcUrl = "https://znyy.amcmj.com/"

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js